import { constants } from 'farmx-api';

export const getRanchEditUrl = (id) => `${constants.ADMIN_URL}/farm/ranch/${id}/`;
